module.exports = __webpack_public_path__ + "static/media/t01ru.ccec0a78.pdf";